module.exports = __webpack_public_path__ + "img/user.65ae5efd.svg";